<script setup lang="ts">
    import type { CSSProperties } from 'vue';

    type Props = {
        prefix?: string;
        suffix?: string;
        decoratedText?: string;
        styleObject?: CSSProperties;
    };

    const props = withDefaults(defineProps<Props>(), {
        prefix: '',
        suffix: '',
        decoratedText: undefined,
        styleObject: () => ({})
    });
</script>

<template>
    <p>
        {{ props.prefix }}<span
            v-if="props.decoratedText"
            :style="props.styleObject"> {{ props.decoratedText }} </span>{{ props.suffix }}
    </p>
</template>
